import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RouterService } from 'src/app/services/router/router.service';
import { environment } from 'src/environments/environment';
import { LogService } from 'src/app/services/log/log.service';
import { LogModel, LogSeverityType } from 'src/app/services/log/log.model';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  constructor(
    private routerService: RouterService,
    private toastr: ToastrService,
    private logService: LogService) { }

  ngOnInit(): void {

  }

  public testWriteLog(){
    let log: LogModel = new LogModel();
    log.LogSeverity = 'Info';
    log.LogText = 'Test';
    this.logService.writeLog(log).subscribe(x => {
      console.log(x);
    });
  }

  public testToastr() {
    this.toastr.info('ここにメッセージ', 'タイトルだよ');
  }
}
